module.exports = __webpack_public_path__ + "img/file-pdf-outline.07bb1b08.svg";